import { IonCard, IonCardContent, IonCardHeader } from "@ionic/react";
import { useHistory, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithNavigation from "../../../hoc/with-navigation";
import TvmForm from "../../../components/common/tvm-form";
import { useSystem } from "../../../store/system";
import { useEffect } from "react";
import { printNumber } from "../../../utils/helpers";
import { TvmFormSubmitResult } from "../../../components/common/tvm-form/form-definition";

import "./styles.css";


const FORM_ID = "trawlGate";

interface GateSelectionResult {
	guincheResult: number | null;
}

const GateSelection = () => {
	const { systemId } = useParams<any>();
	const history = useHistory();

	const systemStore = useSystem();

	const { t } = useTranslation();

	const updateResults = (data: TvmFormSubmitResult<GateSelectionResult>) => {
		systemStore.submitFormResult(systemId, FORM_ID, data);
	};

	useEffect(() => {
		systemStore.loadForm(FORM_ID);
		systemStore.loadFormResult(systemId, FORM_ID);
	}, []);

	return (
		<>
			<WithNavigation
				hintsContent={{
					title: systemStore.currentForm?.hints.title,
					htmlDef: systemStore.currentForm?.hints?.htmlDef || "",
				}}
				preventGoBack={false}
				text={t("system.trawlGates.title")}
			>
				<div className="form">
					{systemStore.currentForm && (
						<>
							{systemStore.formResultReqInfo?.finished && (
								<TvmForm
									title={t("system.trawlGates.gateSelection.title")}
									systemName={systemId}
									definition={systemStore.currentForm}
									fieldValues={systemStore.currentFormValues}
									onSubmit={updateResults}
								/>
							)}
							{
								<IonCard>
									<IonCardContent>
										<div className="ion-text-center">
											<h5 className="calcResultTitle">{t("general.results")}</h5>
											<div className="result-row">
												<p className="label">
													{t("system.trawlGates.gateSelection.trawlCablePull")}
												</p>
												<p className="row-value">
													{systemStore.formFlags?.fresh
														? printNumber(
																systemStore.formResult?.trawlCablePullF
														  )
														: printNumber(
																systemStore.formResult?.trawlCablePullC
														  )}
												</p>
												<p>[kgf]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.trawlGates.gateSelection.gateConsumption")}</p>
												<p className="row-value">
													{systemStore.formFlags?.fresh
														? printNumber(
																systemStore.formResult?.gateConsumptionF
														  )
														: printNumber(
																systemStore.formResult?.gateConsumptionC
														  )}
												</p>
												<p>[kgf]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.trawlGates.gateSelection.gateArea")}</p>
												<p className="row-value">
													{printNumber(systemStore.formResult?.gateAreaC)}
												</p>
												<p>[m²]</p>
											</div>
										</div>
									</IonCardContent>
								</IonCard>
							}
							{
								<IonCard>
									{!systemStore.formResult?.__cond?.result && (
										<IonCardHeader>
											{t("system.trawlGates.gateSelection.mainPowerOutOfRange")}
										</IonCardHeader>
									)}
									{systemStore.formResult?.__cond?.result && (
										<IonCardContent>
											<div className="ion-text-center">
												<h5 className="calcResultTitle">{t("system.trawlGates.gateSelection.empiricalResults")}</h5>
												<div className="result-row">
													<p className="label">
														{
															systemStore.formResult?.__cond?.result.min_area
																.label
														}
													</p>
													<p className="row-value">
														{printNumber(
															systemStore.formResult?.__cond?.result.min_area
																.value
														)}
													</p>
													<p>[m²]</p>
												</div>
												<div className="result-row">
													<p className="label">
														{
															systemStore.formResult?.__cond?.result.max_area
																.label
														}
													</p>
													<p className="row-value">
														{printNumber(
															systemStore.formResult?.__cond?.result.max_area
																.value
														)}
													</p>
													<p>[m²]</p>
												</div>
												<div className="result-row">
													<p className="label">
														{
															systemStore.formResult?.__cond?.result.min_weight
																.label
														}
													</p>
													<p className="row-value">
														{printNumber(
															systemStore.formResult?.__cond?.result.min_weight
																.value
														)}
													</p>
													<p>[kg]</p>
												</div>
												<div className="result-row">
													<p className="label">
														{
															systemStore.formResult?.__cond?.result.max_weight
																.label
														}
													</p>
													<p className="row-value">
														{printNumber(
															systemStore.formResult?.__cond?.result.max_weight
																.value
														)}
													</p>
													<p>[kg]</p>
												</div>
											</div>
										</IonCardContent>
									)}
								</IonCard>
							}
						</>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default GateSelection;
